function isTeeTimeSubmitted(match, teeTimeId) {
  if (match !== undefined) {
    const { teeTimesSubmitted } = match;
    return teeTimesSubmitted?.includes(teeTimeId) ?? false;
  }
  return false;
}

function isMatchCompleted({ teeTimesSubmitted, teeTimesValid }) {
  // at least one match should be submitted
  if (teeTimesSubmitted?.length > 0) {
    // all valid matches should be submitted
    return teeTimesValid.every((id) =>
      isTeeTimeSubmitted({ teeTimesSubmitted }, id),
    );
  }
  return false;
}

export { isMatchCompleted, isTeeTimeSubmitted };
